import React from 'react';
import { WidgetDate, WidgetStatus, ColumnTruncatedText, ColumnStatus } from '../../../../components';
import statuses from '../../../../constants/users/statuses';
import { useTranslation } from 'react-i18next';
// import { ButtonIcon } from '../../../../components';
// import { ActionsSVG } from '../../../../components/svg';
// import UsersMenuDialog from './UsersMenuDialog';
// import { ROLES } from '../../../../constants/permissions/roles';
// import { getUserRole } from '../../../../helpers/LocalStorageHelpers';
// import { palette } from '../../../../styles/theme';

export default function UsersWidgets ({ handleClickMenuUser, setDialog, dialog }) {
    const { t } = useTranslation();
    // const [anchorEl, setAnchorEl] = React.useState(null);

    // const userRole = getUserRole();
    // const canAccessActions = [ROLES.admin, ROLES.userAdmin].includes(userRole);

    // const openMenu = (event, id) => {
    //     setAnchorEl(event.target);
    //     handleClickMenuUser(id);
    // };

    const columns = [{
        dataField: 'id',
        text: t('users.table.columns.id'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'created_at',
        text: t('users.table.columns.created'),
        sort: false,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => (<WidgetDate date={new Date(cellContent)} />),
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'formatted_name',
        text: t('users.table.columns.fullname'),
        sort: false,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => (<ColumnTruncatedText text={cellContent} />),
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'document',
        text: t('users.table.columns.document'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'email',
        text: t('users.table.columns.email'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        dataField: 'role',
        text: t('users.table.columns.role'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: cellContent =>
            !cellContent
                ? ''
                : <ColumnStatus type={statuses[cellContent]?.type} text={`users.table.status.${cellContent}`} />
    }, {
        dataField: 'user_status',
        text: t('users.table.columns.status'),
        align: 'center',
        headerAlign: 'center',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => (<WidgetStatus type={statuses[cellContent]?.type} text={`clients.table.status.${statuses[cellContent]?.id}`} />),
        headerClasses: 'clientsColumnsMC_headers--title',
    }];

    // TODO: The actions column is temporarily hidden to review previous development and perform necessary adjustments in an upcoming release.
    /* columns.push({
        dataField: '',
        text: t('users.table.columns.actions'),
        align: 'center',
        headerClasses: 'clientsColumnsMC_headers--title',
        sort: false,
        formatExtraData: {
            openMenu,
            setDialog,
            dialog,
            anchorEl,
            canAccessActions
        },
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (_cellContent, row, _rowIndex, { openMenu, setDialog, dialog, canAccessActions }) => {
            return (
                <>
                    <ButtonIcon
                        title={t('users.table.columns.actions')}
                        size='small'
                        icon={(<ActionsSVG customStroke={!canAccessActions ? palette.disabled.main : undefined} />)}
                        id={row.id}
                        disabled={!canAccessActions}
                        onClick={(event) => openMenu(event, row.id)} />
                    {
                        dialog?.type === 'menu' && (
                            <UsersMenuDialog row={row} setDialog={setDialog} dialog={dialog} anchorEl={anchorEl} />
                        )
                    }
                </>
            );
        }
    }); */

    return columns;
}
